import type { PaletteOptions } from '@mui/material';
import {
  BLACK,
  DARK_ACCENT,
  GREEN,
  LIGHT_ACCENT,
  ORANGE,
  RED,
  RED_SOFT,
  WHITE,
} from '../base/colors';

const palette: PaletteOptions = {
  lwPrimaryAccentLight: {
    100: LIGHT_ACCENT['100'],
    40: LIGHT_ACCENT['40'],
    20: LIGHT_ACCENT['20'],
    10: LIGHT_ACCENT['10'],
    5: LIGHT_ACCENT['5'],
  },
  lwPrimaryAccentDark: {
    100: DARK_ACCENT['100'],
    80: DARK_ACCENT['80'],
    60: DARK_ACCENT['60'],
    40: DARK_ACCENT['40'],
    30: DARK_ACCENT['30'],
    20: DARK_ACCENT['20'],
    10: DARK_ACCENT['10'],
    5: DARK_ACCENT['5'],
  },
  lwSecondaryAccentLight: {
    100: LIGHT_ACCENT['100'],
    40: LIGHT_ACCENT['40'],
    20: LIGHT_ACCENT['20'],
    10: LIGHT_ACCENT['10'],
    5: LIGHT_ACCENT['5'],
  },
  lwSecondaryAccentDark: {
    100: DARK_ACCENT['100'],
    80: DARK_ACCENT['80'],
    60: DARK_ACCENT['60'],
    40: DARK_ACCENT['40'],
    30: DARK_ACCENT['30'],
    20: DARK_ACCENT['20'],
    10: DARK_ACCENT['10'],
    5: DARK_ACCENT['5'],
  },
  lwWarning: {
    100: ORANGE['100'],
    30: ORANGE['30'],
    20: ORANGE['20'],
  },
  lwDanger: {
    100: RED['100'],
    60: RED['60'],
    20: RED['20'],
    10: RED['10'],
  },
  lwDangerSoft: {
    100: RED_SOFT['100'],
  },
  lwSuccess: {
    100: GREEN['100'],
    20: GREEN['20'],
    10: GREEN['10'],
  },
  lwBlack: {
    100: BLACK['100'],
    60: BLACK['60'],
    40: BLACK['40'],
    30: BLACK['30'],
    20: BLACK['20'],
    10: BLACK['10'],
    2: BLACK['2'],
    6: BLACK['6'],
  },
  lwWhite: {
    100: WHITE['100'],
    80: WHITE['80'],
  },
  lwBlock: {
    actionable: ORANGE['100'],
    default: WHITE['100'],
  },
  lwState: {
    disabled: 'linear-gradient(0deg, rgba(240, 240, 240, 0.5), rgba(240, 240, 240, 0.5)), #FFFFFF',
    borderActive: '#E6EAFF',
  },
  // DO NOT USE
  tertiary: {},
};

export { palette };
